"use client";

import {
  ResponseCampusRelationId,
  ResponseGetCampusRelation,
} from "@/actions/campus/interfaceCampusDetail";

import { ResponseGetYears } from "@/actions/years/interfaceYears";
import { campusGlobal, levelGlobal, yearGlobal } from "@/funtions";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { useEffect, useState } from "react";

import { Controller, useForm } from "react-hook-form";
import { LoadingFilter } from "../../loading/LoadingFilter";
import { globalStorage } from "@/store/globalFiltersStore/globalFilters-store";
import { getRolesFromSession } from "@/helpers/rols/getRoles";
import { useSession } from "next-auth/react";

interface Props {
  yearCookie?: string;
  campusCookies?: string;
  nivelCookies?: string;
  year: ResponseGetYears[];
  campusRelationId: ResponseCampusRelationId;
  campusRelationIdSede: ResponseGetCampusRelation[];
}

export const FormGlobalFilter = ({
  year,
  yearCookie,
  campusRelationId,
  campusRelationIdSede,
  campusCookies,
  nivelCookies,
}: Props) => {
  const { data: session } = useSession();

  const availableRoles = getRolesFromSession(session);

  const { setYear, setCampus, setLevel } = globalStorage();

  const [loading, setLoading] = useState(true);

  const {
    register,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm<any>({
    defaultValues: {
      //yearId: year.filter((año) => año.name === "2024")[0].id
    },
  });

  useEffect(() => {
    if (!yearCookie && year?.length > 0) {
      const yearInitial = year[0]?.id ?? "";
      const yearName = year[0]?.name ?? "";

      yearGlobal(String(yearInitial), String(yearName));
      setYear(String(yearInitial));
    }
  }, []);

  useEffect(() => setLoading(false), [campusRelationId]);

  return (
    <div className="grid grid-cols-3 gap-2 lg:gap-5 items-center">
      <Controller
        name="yearId"
        defaultValue={
          year.length > 0
            ? yearCookie == undefined || yearCookie == null || !yearCookie
              ? year[0]?.id
              : yearCookie
            : null
        }
        control={control}
        render={({ field: { onChange, value } }) => (
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Años</InputLabel>
            <Select
              required
              onChange={(e) => {
                const selectedId = e.target.value;

                onChange(selectedId);

                const selectedYear = year.find((y) => y.id === selectedId);

                yearGlobal(selectedId, selectedYear?.name ?? "");

                setValue("campusId", "");
                setValue("levelId", "");
                setYear(selectedId || "");
              }}
              value={value || ""}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Años"
              className="w-full md:w-[100px] placeholder:text-[12px] text-[12px] h-[35px] md:h-auto md:text-base"
            >
              {Array.isArray(year)
                ? year.map((year) => (
                  <MenuItem key={year.id} value={year.id}>
                    {year.name}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        )}
      />

      {availableRoles.length !== 1 && (
        <Controller
          name="campusId"
          defaultValue={campusCookies || ""}
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" className="text-[12px]">
                Sedes
              </InputLabel>
              <Select
                onChange={(e) => {
                  onChange(e);
                  campusGlobal(e.target.value);
                  //router.refresh()
                  setLoading(true);
                  setValue("levelId", "");
                  setCampus(e.target.value || "");
                }}
                value={value || ""}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Sedes"
                className="w-full md:w-full placeholder:text-[12px] text-[12px] h-[35px] md:h-auto md:text-base"
              >
                {campusRelationIdSede?.length > 0 &&
                  (Array.isArray(campusRelationIdSede)
                    ? campusRelationIdSede?.map((sede) => (
                      <MenuItem key={sede.id} value={sede.id}>
                        {sede.campusDetail.name}
                      </MenuItem>
                    ))
                    : null)}
              </Select>
            </FormControl>
          )}
        />
      )}

      {availableRoles.length !== 1 && (
        <Controller
          name="levelId"
          defaultValue={nivelCookies || ""}
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormControl fullWidth size="small">
              <InputLabel
                id="demo-simple-select-label"
                className="text-[12px] p-0"
              >
                Nivel
              </InputLabel>
              <Select
                onChange={(e) => {
                  onChange(e);
                  levelGlobal(e.target.value);
                  //router.refresh()
                  setLevel(e.target.value || "");
                }}
                value={value || ""}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Nivel"
                className="w-full md:w-[200px] h-[35px] md:h-auto md:text-base"
              >
                {loading ? (
                  <LoadingFilter />
                ) : (
                  (campusRelationId?.campusToLevel || [])?.map((nivel) => (
                    <MenuItem key={nivel.level.id} value={nivel.level.id}>
                      {nivel.level.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          )}
        />
      )}
    </div>
  );
};
